export default __webpack_public_path__ + "static/media/cross-big.2892fc64.svg";